export default __webpack_public_path__ + "static/media/zain.07e8411d.svg";